import { render, staticRenderFns } from "./numberOfRepairs.vue?vue&type=template&id=42b5e296&scoped=true&"
import script from "./numberOfRepairs.vue?vue&type=script&lang=js&"
export * from "./numberOfRepairs.vue?vue&type=script&lang=js&"
import style0 from "./numberOfRepairs.vue?vue&type=style&index=0&id=42b5e296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5e296",
  null
  
)

export default component.exports